export const getDbInstance = (dbName:string, storeName:string):Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, 1);
  
      request.onupgradeneeded = (event:IDBVersionChangeEvent) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'id' });
        }
      };
  
      request.onsuccess = (event:Event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        resolve(db);
      };
  
      request.onerror = (event:Event) => {
        const error = (event.target as IDBOpenDBRequest).error;
        reject(error);
      };
    });
  };